module.exports = __webpack_public_path__ + "img/secondary-title.b0754641.png";